import { render, staticRenderFns } from "./attchmentEditor.vue?vue&type=template&id=1a598951&scoped=true&"
import script from "./attchmentEditor.vue?vue&type=script&lang=js&"
export * from "./attchmentEditor.vue?vue&type=script&lang=js&"
import style0 from "./attchmentEditor.vue?vue&type=style&index=0&id=1a598951&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a598951",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\2000HuiTian\\huitianadmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a598951')) {
      api.createRecord('1a598951', component.options)
    } else {
      api.reload('1a598951', component.options)
    }
    module.hot.accept("./attchmentEditor.vue?vue&type=template&id=1a598951&scoped=true&", function () {
      api.rerender('1a598951', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/attchmentEditor.vue"
export default component.exports